import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  id: string;
  data: any; //TODO: fix type;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  id: "",
  data: null,
};

const getEarlyRegistrationDetailSlice = createSlice({
  name: "getEarlyRegistrationDetail",
  initialState,
  reducers: {
    setEarlyRegistrationDetailId: (state, action: PayloadAction<string>) => {
      state.id = action.payload;
    },
    resetEarlyRegistrationDetailId: (state) => {
      state.id = "";
    },
    getEarlyRegistrationDetailStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getEarlyRegistrationDetailSuccess: (state, action: PayloadAction<any>) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },

    getEarlyRegistrationDetailFailed: (
      state,
      action: PayloadAction<string>
    ) => {
      state.status = ReduxStateType.ERROR;
      state.data = action.payload;
    },
    resetEarlyRegistrationDetail: () => {
      return { ...initialState };
    },
  },
});

export const {
  setEarlyRegistrationDetailId,
  resetEarlyRegistrationDetailId,
  getEarlyRegistrationDetailStart,
  getEarlyRegistrationDetailSuccess,
  getEarlyRegistrationDetailFailed,
  resetEarlyRegistrationDetail,
} = getEarlyRegistrationDetailSlice.actions;

export default getEarlyRegistrationDetailSlice.reducer;
